import React, { PropsWithChildren } from 'react'
import { useDialogActions } from 'cityads-v3/hooks/dialog'
import classes from './LandingsButton.scss'

import Drawer from '@mui/material/Drawer'
import LandingsList, { LandingsListProps } from './LandingsList'


type LandingsButtonProps = PropsWithChildren<{
  className?: string,
}> & LandingsListProps

export default function LandingsButton({
  children,
  className,
  ...rest
}: LandingsButtonProps): JSX.Element {
  const [open, handleOpen, handleClose] = useDialogActions()

  return (
    <>
      <button className={className} onClick={handleOpen}>
        {children}
      </button>

      <Drawer
        anchor="right"
        classes={{ paper: classes.drawer }}
        open={open}
        onClose={handleClose}
      >
        <LandingsList
          {...rest}
        />
      </Drawer>
    </>
  )
}
